import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  HiOutlineChevronRight,
  HiOutlineClipboardList,
  HiOutlineCurrencyDollar,
  HiOutlineLogout,
  HiOutlineMenuAlt2,
  HiOutlineUserAdd,
  HiOutlineUsers,
  HiOutlineCalendar,
  HiOutlineShieldCheck,
  HiX,
} from 'react-icons/hi';
import { useAuth } from '../../context/AuthContext';

const adminLinks = [
  { to: '/employees', icon: HiOutlineUsers, label: 'Employees' },
  { to: '/attendance', icon: HiOutlineClipboardList, label: 'Attendance' },
  { to: '/payroll', icon: HiOutlineCurrencyDollar, label: 'Payroll' },
  { to: '/administration', icon: HiOutlineShieldCheck, label: 'Credential' },
];

const publicLinks = [
  { to: '/employee-registry', icon: HiOutlineUserAdd, label: 'Employee Registry' },
  { to: '/cl-registry', icon: HiOutlineCalendar, label: 'Leave Portal' },
];

export default function Sidebar() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
  const confirmLogout = window.confirm('Are you sure you want to logout?');

  if (confirmLogout) {
    logout();
    navigate('/login');
  }
};

  const linkClassName = ({ isActive }, collapsedMode) => `
    flex items-center gap-3 px-3 py-3 rounded-2xl transition-all duration-200 group relative border
    ${isActive
      ? 'text-black border-gold-500/20 shadow-gold bg-white/80'
      : 'text-white/90 hover:text-slate-900 hover:bg-white/80 border-transparent'
    }
    ${collapsedMode ? 'justify-center' : ''}
  `;

  const sidebarContent = (
    // bg-[#020617]
    <div className="flex flex-col h-full bg-slate-800">
      <div onClick={() => navigate('/employees')} className={`cursor-pointer flex flex-col px-5 pt-6 pb-2 border-b border-gold-500/10 items-center gap-3 ${collapsed ? 'justify-center px-3' : ''}`}>
        {/* <div className="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0 bg-gold-gradient shadow-gold">
          <span className="text-white font-display font-bold text-base">H</span>
        </div> */}
        {/* <img src="/assets/logo.svg" alt="logo" className='w-24' /> */}

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 1024 1024">
  <defs>
    <linearGradient id="linear-gradient" y1="1" x2="1" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#973cfd"/>
      <stop offset="0.508" stop-color="#df4bc9"/>
      <stop offset="1" stop-color="#fb9759"/>
    </linearGradient>
  </defs>
  <g id="Group_3444" data-name="Group 3444" transform="translate(5.027 9)">
    <circle id="Ellipse_104" data-name="Ellipse 104" cx="512" cy="512" r="512" transform="translate(-5.027 -9)" fill="url(#linear-gradient)"/>
    <g id="Group_3447" data-name="Group 3447" transform="translate(189.48 113.329)">
      <path id="Path_7078" data-name="Path 7078" d="M494.246,158.351a2.285,2.285,0,0,0,0,.74,177.035,177.035,0,0,1-61.15,189.5,178.819,178.819,0,0,1-62.818,31.475A184.33,184.33,0,0,1,149.2,264.485,182.813,182.813,0,0,1,247.3,36.027a3.937,3.937,0,0,0,0-7.233A222.24,222.24,0,0,0,184.57,10.709a2.015,2.015,0,0,0-.992,0,235.227,235.227,0,0,0,53.21,415.841,237.812,237.812,0,0,0,241.957-48.928,234.781,234.781,0,0,0,66.741-236.451,172.738,172.738,0,0,0-28.181-53.188,1.407,1.407,0,0,0-2.479.492C508.877,108.781,507.637,117.495,494.246,158.351Z" transform="translate(0 334.84)" fill="#fff"/>
      <path id="Path_7079" data-name="Path 7079" d="M86.82,85.482,109.715,6.244a238.134,238.134,0,0,1,85.291,53.143,256.414,256.414,0,0,1,57.85,84.787,301.082,301.082,0,0,1,20.911,95.362c5.206,115.389-61.241,196.619-79.341,217.253-4.71,5.377-10.332,10.663-13.139,13.524,4.627-7.454,12.4-19.246,19.337-32.51,15.042-28.781,31.408-60.165,38.349-94.755a222.986,222.986,0,0,0-14.546-127.265,225.052,225.052,0,0,0-78.018-94.15c-20.164-14.911-58.845-27.742-61.572-28.956" transform="translate(136.766 196.807)" fill="#fff"/>
      <path id="Path_7081" data-name="Path 7081" d="M86.172,48.916l40.908-37.1a186.385,186.385,0,0,1,59.589,68.313,199.2,199.2,0,0,1,20.617,95.633,198.219,198.219,0,0,1-27.227,93.794,161.752,161.752,0,0,1-15.209,20.285,159.785,159.785,0,0,0,23.639-71.78,164.057,164.057,0,0,0-15.95-83.4c-16.945-35.33-44.55-63.8-78.514-80.969-3.554-1.91-6.613-3.3-8.68-4.248" transform="translate(153.27 377.405)" fill="#fff"/>
      <path id="Path_7084" data-name="Path 7084" d="M147.358,128a64,64,0,1,0-64-64A64,64,0,0,0,147.358,128Z" transform="translate(79.832 3.854)" fill="#fff"/>
      <path id="Path_7086" data-name="Path 7086" d="M86.914,122.988C98.978,83.2,112.285,40.629,124.352.924,181.981,21.471,229.523,65.1,256.585,122.294a278.418,278.418,0,0,1,25.538,81.752,457.234,457.234,0,0,1-8.265,203.9C237.08,540.936,145.012,619.915,113.692,644.19a406.813,406.813,0,0,0,69.01-93.372,340.21,340.21,0,0,0,41.324-143.65,335.56,335.56,0,0,0-39.672-175.033A324.473,324.473,0,0,0,115.1,146.222c-11.82-10.4-26.282-20.633-26.282-20.633l-1.736-1.3v-.953" transform="translate(204.277 22.931)" fill="#fff"/>
      <path id="Path_7088" data-name="Path 7088" d="M131.756,105.406a50,50,0,1,0-50-50A50,50,0,0,0,131.756,105.406Z" transform="translate(39.845 177.646)" fill="#fff"/>
    </g>
  </g>
</svg>

        </div>
        {!collapsed && (
          <div>
            <div className="text-white font-semibold text-2xl leading-tight">GrailHRMS</div>
            {/* <div className="text-slate-500 text-xs tracking-[0.3em] uppercase">Luxury Desk</div> */}
          </div>
        )}
      </div>

      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
        {!collapsed && (
          <div className="px-3 py-2 text-xs text-slate-400 font-medium tracking-[0.1em] uppercase">
            Portal
          </div>
        )}

        {publicLinks.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} className={(state) => linkClassName(state, collapsed)}>
            <Icon className="w-5 h-5 flex-shrink-0" />
            {!collapsed && <span className="text-[13px] font-medium tracking-[0.05em]">{label}</span>}
          </NavLink>
        ))}

        {admin && (
          <>
            {!collapsed && (
              <div className="px-3 pt-4 pb-2 text-xs text-slate-400 font-medium tracking-[0.1em] uppercase">
                Administration
              </div>
            )}

            {collapsed && <div className="gold-line my-3 mx-2 opacity-40" />}

            {adminLinks.map(({ to, icon: Icon, label }) => (
              <NavLink key={to} to={to} className={(state) => linkClassName(state, collapsed)}>
                <Icon className="w-5 h-5 flex-shrink-0" />
                {!collapsed && <span className="flex-1 text-[13px] font-medium tracking-[0.05em]">{label}</span>}
              </NavLink>
            ))}
          </>
        )}
      </nav>

      <div className="border-t border-gold-500/10 p-3">
        {admin ? (
          <div className={`flex items-center gap-3 ${collapsed ? 'justify-center' : ''}`}>
            {!collapsed && (
              <div className="flex-1 min-w-0">
                {/* <div className="text-white/60 text-sm font-semibold truncate">{admin.username}</div> */}
                <div className="text-white/80 text-xs uppercase tracking-[0.1em]">{admin.role}</div>
              </div>
            )}
            <button
  onClick={() => setShowLogoutConfirm(true)}
  className="p-2 rounded-xl text-white/80 hover:text-crimson-400 hover:bg-crimson-500/10 transition-all"
  title="Logout"
>
  <HiOutlineLogout className="w-5 h-5" />
</button>
          </div>
        ) : (
          !collapsed && (
            <NavLink to="/login" className="flex items-center gap-2 px-3 py-2 text-gold-600 hover:text-gold-500 text-sm transition-colors">
              <HiOutlineChevronRight className="w-4 h-4" />
              Admin Login
            </NavLink>
          )
        )}
      </div>
      {showLogoutConfirm && (
  <div className="fixed inset-0 z-[100] flex items-end">
    {/* Overlay */}
    <div
      className="absolute inset-0 bg-black/40"
      onClick={() => setShowLogoutConfirm(false)}
    />

    {/* Bottom Sheet */}
    <div className="relative w-full bg-[#020617] rounded-t-3xl p-6 border-t border-gold-500/20 animate-slideUp">
      
      <div className="w-12 h-1.5 bg-white/20 rounded-full mx-auto mb-4" />

      <h2 className="text-center text-white text-lg font-semibold mb-2">
        Logout?
      </h2>
      <p className="text-center text-white/60 text-sm mb-6">
        You will need to login again to access your account.
      </p>

      <button
        onClick={() => {
          logout();
          navigate('/login');
        }}
        className="w-full py-3 mb-2 rounded-xl bg-crimson-500 text-white font-medium"
      >
        Yes, Logout
      </button>

      <button
        onClick={() => setShowLogoutConfirm(false)}
        className="w-full py-3 rounded-xl bg-white/10 text-white/80"
      >
        Cancel
      </button>
    </div>
  </div>
)}

<style>
  {`
  @keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}
.animate-slideUp {
  animation: slideUp 0.25s ease-out;
}
  `}
</style>
    </div>
  );

  return (
    <>
      <aside
        className={`hidden md:flex flex-col h-full transition-all duration-300 flex-shrink-0 ${
          collapsed ? 'w-[72px]' : 'w-[260px]'
        } bg-[rgba(248,250,252,0.8)] backdrop-blur-xl border-r border-slate-200 shadow-[0_12px_40px_rgba(15,23,42,0.08)]`}
      >
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="absolute top-0 right-[-12px] z-10 w-9 h-9 bg-obsidian-900 border border-gold-500/20 rounded-[0_0_0_14px]
          flex items-center justify-center text-slate-500 hover:text-gold-600 transition-all shadow-gold"
        >
          <HiOutlineMenuAlt2 className={`w-5 h-5 transition-transform duration-300 ${collapsed ? 'rotate-180' : ''}`} />
        </button>
        {sidebarContent}
      </aside>

      <button
        onClick={() => setMobileOpen(true)}
        className="md:hidden fixed top-4 left-4 z-50 p-2.5 bg-[rgba(248,250,252,0.95)] border border-slate-200 rounded-2xl text-slate-600 shadow-sm"
      >
        <HiOutlineMenuAlt2 className="w-5 h-5" />
      </button>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-[rgba(29,26,22,0.28)] backdrop-blur-sm" onClick={() => setMobileOpen(false)} />
          <aside className="relative w-[260px] bg-[rgba(248,250,252,0.98)] backdrop-blur-xl border-r border-slate-200 h-full shadow-[0_20px_40px_rgba(15,23,42,0.14)]">
            <button
              onClick={() => setMobileOpen(false)}
              className="absolute top-4 right-4 text-slate-500 hover:text-slate-900"
            >
              <HiX className="w-5 h-5" />
            </button>
            {sidebarContent}
          </aside>
        </div>
      )}
    </>
  );
}
